import AddIcon from '@mui/icons-material/Add'
import FavoriteIcon from '@mui/icons-material/Favorite'
import { Link ,  Fab } from '@mui/material'
import {  styled } from '@mui/system'

import { primaryDarkColour } from '../theme'


const Container = styled('div')(() => ({
  // border: '1px solid red',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  columnGap: '2rem'
}))

const MenuContainer = styled('div')(() => ({
  // border: '1px solid blue',
  // Height: '12rem',
  // marginBottom: '2rem',
  display: 'flex',
  alignItems: 'center',
  columnGap: '2rem',
  transform: 'translateY(-1rem)'
}))

export const GlobalLinkStyled = styled(Link)(() => ({
  '&:hover': {
    color: primaryDarkColour,
    // display: ''
    textDecoration: 'none'
  }
}))

export default function NavBar ({ isFilterByLiked, setFilterLiked, showAddSasaviForm }) {
  
  const handleLikeFilter = () => {
    setFilterLiked(!isFilterByLiked)
  }

  return (
    <Container>
      <MenuContainer>
      <Fab
        // disabled={isFilterByLiked} // Disable the Fab if the item is already liked
        color={'primary'} // Change color if liked
        aria-label="add sasavi"
        onClick={showAddSasaviForm}
      >
        <AddIcon />
      </Fab>
      <Fab
        // disabled={isFilterByLiked} // Disable the Fab if the item is already liked
        color={isFilterByLiked ? 'primary' : 'default'} // Change color if liked
        aria-label="like"
        onClick={handleLikeFilter}
      >
        <FavoriteIcon />
      </Fab>
        {/* <a href='/'>
          <img height={70}  src={logo} alt="SaSaVi Logo" />
        </a> */}
      </MenuContainer>
    </Container>
  )
}